import React from 'react';
import PageTemplate from './page-template';
import PageSlider from './page-slider';
import { Swiper, SwiperProps } from 'swiper/swiper-react';

type MainPagePropsType = {
    geoIpCountry: string | null;
};

export default function MainPage(props: MainPagePropsType) {
    const [swiper, setSwiper]: [
        typeof Swiper | undefined,
        React.Dispatch<React.SetStateAction<typeof Swiper | undefined>>,
    ] = React.useState();
    const [slide, setSlide] = React.useState(0);
    const [height, setHeight] = React.useState(0);

    React.useEffect(() => {
        if (global.window.innerHeight) {
            setHeight(global.window.innerHeight);
        }
    }, [setHeight]);

    const updateSlidePosition = ({ activeIndex }: { activeIndex: number }) => {
        setSlide(activeIndex);

        // magic for ios safari, doesn't affect othe browser.
        // @todo: make it work in page-slider
        if (activeIndex === 4) {
            global.window.scroll(0, 1000);
        } else {
            global.window.scroll(0, -1000);
        }
    };
    const onInitHandler: SwiperProps['onInit'] = (instance) => {
        // @ts-ignore
        setSwiper(instance);
    };
    const onResizeHandler: SwiperProps['onResize'] = (resizedSwiper) => {
        // need to rethink it later
        setTimeout(() => {
            resizedSwiper.updateSize();
        }, 200);
    };
    // @ts-ignore
    const goToTopHandler = swiper ? () => swiper.slideTo(0, 500) : undefined;

    const themeTextColor = [1, 3].includes(slide) ? '#FFCA36' : undefined;

    return (
        <PageTemplate
            color={themeTextColor}
            goToTopHandler={goToTopHandler}
            showGoToButton={slide !== 0}
            content={
                <PageSlider
                    height={height}
                    onRealIndexChange={updateSlidePosition}
                    onInit={onInitHandler}
                    onResize={onResizeHandler}
                    showFaqLink={props.geoIpCountry === 'us'}
                    goToTopHandler={goToTopHandler}
                    slideIndex={slide}
                />
            }
            extraClass={`page--font-new page--header-fixed page--footer-fixed ${
                [1, 2, 3].includes(slide) ? 'has-slider-pagination' : ''
            } ${[2].includes(slide) ? 'has-slider-white-pagination' : ''}`}
        />
    );
}
